export const reviewPageES = {
	eyebrow: "Tu opinión",
	title: "Deja una reseña",
	editTitle: "Editar tu reseña",
	ask: "¿Cómo estuvo tu visita?",
	// El índice 0 es el texto antes de elegir calificación.
	ratings: ["Haz clic para calificar", "Muy malo", "Malo", "Regular", "Bueno", "Excelente"],
	placeholder: "Comparte tu experiencia...",
	anonymous: "Enviar esta reseña de forma anónima",
	submit: "Enviar reseña",
	save: "Guardar cambios",
	submitting: "Enviando...",
	back: "Volver",
	editHint: "Ya reseñaste esta cita. Al actualizarla reemplazas lo que escribiste antes.",
	errorNoRating: "Elige una calificación antes de continuar.",
	errorSubmit: "No pudimos enviar tu reseña. Inténtalo de nuevo.",
	errorLoad: "No pudimos cargar esta reserva, así que aún no hay nada que reseñar. Inténtalo de nuevo.",
	commentLabel: "Agrega un comentario (opcional)",
};
